"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = obj => obj && obj.__isYupSchema__;

exports.default = _default;